import classNames from 'classnames'
import CommonIcon from 'CommonIcon'
import moment from 'locale/momentLocale'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { countryIdToString } from 'utils/countryUtils'

import Box from '@mui/material/Box'

class GeneralTab extends Component {
  render() {
    const { countryId, dateCurrent, details, isSisterStore, t } = this.props
    const {
      address1,
      address2,
      closeDate,
      cluster = '',
      concept,
      floorSpace,
      floorSpaceHistory = [],
      openDate,
      openingHourFrom,
      openingHourTo,
      regionalManager,
      regionManagerPhone,
      renovations,
      storeId,
    } = details
    const countryName = countryIdToString(countryId)
    const translatedCountryName = t(`countries.${countryName}`)
    const flag = isSisterStore ? details.logo || countryName : countryName

    return (
      <>
        <div className="store-details-info_address">
          <Box className="address1" display="flex">
            {flag && <CommonIcon name={flag} />}

            <div className={classNames('flex-column', { location: flag })}>{address1}</div>
          </Box>

          <Box className="address2" display="flex">
            {address2}
          </Box>

          {openingHourFrom && (
            <Box display="flex">
              {t('revenue.table.openingHours')}: {openingHourFrom}
              {openingHourTo && ` - ${openingHourTo}`} ({moment(dateCurrent).format('L')})
            </Box>
          )}

          {countryName && (
            <Box className="store-details-info_country-name" display="flex">
              <div>
                <span>{translatedCountryName[0]}</span>
                {translatedCountryName.slice(1)}
              </div>
            </Box>
          )}
        </div>
        <Box display="flex" key={storeId}>
          <div className="column left">
            <ul className="store-details-info_content">
              <li>
                <span className="store-details-info_content_name">{t('revenue.table.category')}:</span>
                <span className={classNames('store-details-info_content_value category', `is-${cluster.toLocaleLowerCase()}`)}>
                  {cluster}
                </span>
              </li>
              <li>
                <span className="store-details-info_content_name">{t('revenue.table.trim')}:</span>
                <span className="store-details-info_content_value">{concept}</span>
              </li>
              <li>
                <span className="store-details-info_content_name">{t('revenue.table.openDate')}:</span>
                <span className="store-details-info_content_value">{moment(openDate).format('L')}</span>
              </li>
              {renovations && (
                <li>
                  <span className="store-details-info_content_name">{t('revenue.table.renovations')}:</span>
                  <div>
                    {renovations.split(' | ').map(date => (
                      <div key={date} className="store-details-info_content_value">
                        {date}
                      </div>
                    ))}
                  </div>
                </li>
              )}
              <li>
                <span className="store-details-info_content_name">{t('revenue.table.closeDate')}:</span>
                <span className="store-details-info_content_value">{closeDate ? moment(closeDate).format('L') : '-'}</span>
              </li>
              <li>
                <span className="store-details-info_content_name">{t('revenue.table.rks')}:</span>
                <span className="store-details-info_content_value">{regionalManager}</span>
              </li>
              {regionManagerPhone && (
                <li>
                  <span className="store-details-info_content_name">{t('revenue.table.regionManagerPhone')}:</span>
                  <span className="store-details-info_content_value">
                    <a href={`tel:${regionManagerPhone}`}>{regionManagerPhone}</a>
                  </span>
                </li>
              )}
              <li className="store-details-info_content_row-spacing">
                <span className="store-details-info_content_name">{t('revenue.stats.generalSurface')}:</span>
                <span className="store-details-info_content_value">
                  {floorSpace} m<sup>2</sup>
                </span>
              </li>
              <li>
                <div className="flex-column">
                  <span className="store-details-info_content_name">{t('revenue.stats.surface')}:</span>
                </div>
                <div className="flex-column">
                  {floorSpaceHistory.map(({ floorSpace: floor, dateFrom }, index) => (
                    <span key={index} className="store-details-info_content_value">
                      {floor} m<sup>2</sup>
                      <span className="store-details-info_content_time">
                        {t('revenue.table.from')} {moment(dateFrom).format('L')}
                      </span>
                    </span>
                  ))}
                </div>
              </li>
            </ul>
          </div>
          <div className="column right">
            <i className={classNames('icon', { 'shop-icon': !isSisterStore, 'related-shop-icon': isSisterStore })} />
          </div>
        </Box>
      </>
    )
  }
}

GeneralTab.propTypes = {
  countryId: PropTypes.string,
  dateCurrent: PropTypes.string,
  details: PropTypes.object,
  isSisterStore: PropTypes.bool,
  t: PropTypes.func,
}

export default withTranslation()(GeneralTab)
